import {
  Button,
  FixedFooter,
  Accordion,
  SubAccordion,
  Modal,
} from "@components/";
import { useHome } from "./useHome";
import { useRef, useState } from "react";
import { useZendeskData } from "../../hooks";

export function Home() {
  const pageRef = useRef<HTMLDivElement>(null);
  const { navigate, pedidos, isLoading, error, deletePedido } = useHome();
  const { ticketId } = useZendeskData();

  const [modalOpen, setModalOpen] = useState(false);
  const [pedidoToDelete, setPedidoToDelete] = useState<{
    id: string;
    title: string;
  } | null>(null);

  const handleConfirmDelete = () => {
    if (pedidoToDelete) {
      deletePedido(pedidoToDelete.id, pedidoToDelete.title);
      setModalOpen(false);
      setPedidoToDelete(null);
    }
  };

  const handleCancelDelete = () => {
    setModalOpen(false);
    setPedidoToDelete(null);
  };

  return (
    <div
      ref={pageRef}
      className="h-full flex flex-col gap-[6.5px] py-[22.5px] px-4 mb-8"
    >
      <h1 className="text-[18px] font-semibold">Pedidos</h1>
      <h2 className="text-[14px] font-medium">
        Pedidos vinculados ao ticket #{ticketId || "..."}
      </h2>

      <h2 className="text-[14px] font-medium text-[#87929D]">
        Total de pedidos: {isLoading ? "..." : pedidos.length}
      </h2>

      {/* Loading state */}
      {isLoading && (
        <div className="mb-auto mt-auto flex items-center justify-center">
          <h4 className="text-center text-[14px] text-[#87929D] font-reg">
            Carregando pedidos...
          </h4>
        </div>
      )}

      {error && !isLoading && (
        <div className="mb-auto mt-auto flex items-center justify-center">
          <h4 className="text-center text-[14px] text-red-500 font-reg">
            {error}
          </h4>
        </div>
      )}
      {!isLoading && !error && pedidos.length === 0 && (
        <div className="mb-auto mt-auto flex flex-col items-center justify-center gap-2">
          <h4 className="text-center text-[14px] text-[#87929D] font-reg">
            Nenhum pedido encontrado
          </h4>
        </div>
      )}

      {/* Pedidos list */}
      {!isLoading && !error && pedidos.length > 0 && (
        <>
          {pedidos.map((pedido, index) => (
            <Accordion
              key={pedido.id}
              title={pedido.title}
              fields={pedido.fields}
              values={pedido.values}
              defaultOpen={index === 0}
            >
              <div>
                {/* <SubAccordion
                  item={{
                    title: "Conta",
                    fields: ["Nome", "Código ERP", "CPF", "OrderId LGPD"],
                    values: [
                      "Denise Pereira Rosa Valverde",
                      <span key="erp" className="text-blue-600 underline">
                        34419957
                      </span>,
                      "552.587.367-02",
                      "3170446352397",
                    ],
                  }}
                /> */}

                {pedido.products && pedido.products.length > 0 ? (
                  pedido.products.map((product, productIndex) => (
                    <SubAccordion
                      key={productIndex}
                      item={{
                        title: `Produto ${productIndex + 1}`,
                        badge: "1",
                        fields: [
                          "Nome",
                          "Código do produto",
                          "Marca",
                          "Linha",
                          "Família do produto",
                          "Código ERP",
                          "Ativo",
                          "Peso",
                          "Altura",
                          "Largura",
                          "Profundidade",
                          "Quantidade",
                          "Preço",
                        ],
                        values: [
                          product.produtoComercial || "-",
                          product.codigo || "-",
                          product.marca || "-",
                          product.linha || "-",
                          product.familiaProduto || "-",
                          product.codigoErp || "-",
                          product.ativo || "-",
                          product.peso || "-",
                          product.altura || "-",
                          product.largura || "-",
                          product.profundidade || "-",
                          product.quantidade || "-",
                          product.preco || "-",
                        ],
                      }}
                    />
                  ))
                ) : (
                  <SubAccordion
                    item={{
                      title: "Produtos",
                      badge: "0",
                      fields: ["Status"],
                      values: ["Nenhum produto encontrado"],
                    }}
                  />
                )}
              </div>

              {/* Botões de ação */}
              <div className="p-4 flex gap-2 border-t border-gray-200">
                <Button
                  size="small"
                  variant="outline"
                  onClick={() => {
                    navigate(`/order/${pedido.id}`);
                  }}
                >
                  Visualizar e editar
                </Button>
                <Button
                  size="small"
                  variant="outline-danger"
                  onClick={() => {
                    console.log("🔍 Botão remover clicado!", {
                      id: pedido.id,
                      title: pedido.title,
                    });
                    setPedidoToDelete({ id: pedido.id, title: pedido.title });
                    setModalOpen(true);
                  }}
                >
                  Remover
                </Button>
              </div>
            </Accordion>
          ))}
        </>
      )}

      <FixedFooter pageRef={pageRef}>
        <Button
          variant="outline"
          onClick={() => {
            navigate("/new-order");
          }}
        >
          Novo pedido
        </Button>
      </FixedFooter>

      {/* Modal de confirmação para deletar pedido */}
      <Modal
        isOpen={modalOpen}
        onClose={handleCancelDelete}
        onConfirm={handleConfirmDelete}
        title="Tem certeza?"
        variant="danger"
        confirmText="Confirmar"
        cancelText="Cancelar"
      >
        Tem certeza de que deseja remover este <strong>pedido</strong>?
      </Modal>
    </div>
  );
}
